import moment from 'moment';
import React, { createContext, useContext, useState } from 'react';

const INGContext = createContext();

export const INGContextProvider = ({ children }) => {

    // startDate/endDate always default to today — the ingReport API expects
    // the current date on page load.
    const [GlobalFilter, setGlobalFilters] = useState({
        search: [],
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        city: [],
        depot: [],
        contract: [],
        engineStatus: '',
        ignitionStatus: ''
    });

    return (
        <INGContext.Provider value={{ GlobalFilter, setGlobalFilters }}>
            {children}
        </INGContext.Provider>
    );
};

export const useINGContextData = () => useContext(INGContext);
